import script from "./RootTimelapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootTimelapse.vue?vue&type=script&setup=true&lang=ts"

import "./RootTimelapse.vue?vue&type=style&index=0&id=1a58308e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a58308e"]])

export default __exports__